export default {
    getHomeMatches: state => state.homeMatches,
    getHomeVisitors: state => state.homeVisitors,
    getHomeMeetings: state => state.homeMeetings,
    getHomeMessages: state => state.homeMessages,
    getHomeOnline: state => state.homeOnline
};